// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { qMainnet as _qMainnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the qMainnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 35441
 * Chain Name: Q Mainnet
 * Default Block Explorer: https://explorer.q.org
 * Default RPC URL: https://rpc.q.org
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { qMainnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: qMainnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const qMainnet = createCommon({
	..._qMainnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
